export async function installPortfolio() {
  const { PagesPortfolio } = await import("@/wc/pages/portfolio/index.tsx");
  return PagesPortfolio;
}
